import { Gutter } from 'antd/es/grid/row'

export const gutter: [Gutter, Gutter] = [
  {
    xs: 16,
    sm: 16,
    md: 20,
    lg: 24,
    xl: 24,
    xxl: 24,
  },
  {
    xs: 16,
    sm: 16,
    md: 20,
    lg: 24,
    xl: 24,
    xxl: 24,
  },
]

export const formGutter: Gutter = {
  xs: 16,
  sm: 16,
  md: 16,
  lg: 16,
  xl: 16,
  xxl: 16,
}
